module.exports = __webpack_public_path__ + "static/img/inquiry_active_bg.e331a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/inquiry_active_bg.png
// module id = P++G
// module chunks = 1